import * as React from 'react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

import { localeData } from '../../locales/data';
import { StateType } from '../../reducers';
import { convertArrayFromDropdown } from '../../shared/helpers';
import { useAppDispatch } from '../../shared/services/store/useAppDispatch';

import { SelectProps } from './types';
import { FieldSet } from './FieldSet';
import { FormattedMessageHelper } from '../../shared/helpers/internationalization';

const SelectConnect = (props: SelectProps) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  // @ts-ignore
  const value: any = useSelector((state: StateType) => state.getIn(props.pathValue));
  // @ts-ignore
  const errors: any = useSelector((state: StateType) => state.getIn(props.pathErrors));
  // @ts-ignore
  const options: any = useSelector((state: StateType) => state.getIn(props.pathOptions));

  const dispatchChangeField = useCallback(
    (_: any, data: any) => dispatch(props.onChangeFieldAction(data)),
    [dispatch, props.onChangeFieldAction]
  );

  const createdOptions = (firstKey: string, lastKey: string) => {
    let createdOpts: any = [];
    if (options && options.get(firstKey) && options.get(lastKey)) {
      for (let i: number = options.get(firstKey); i <= options.get(lastKey); i = i + 1) {
        createdOpts = createdOpts.concat({ label: i.toString(), value: i });
      }
    }

    return createdOpts;
  };

  const setOptions = () => {
    const { shouldCreatedOptions = false, firstOptionKey = '', lastOptionKey = '' } = props;

    if (!options) {
      const newValue = !value ? '' : value;

      return [{ label: newValue, value: newValue }];
    } else {
      return shouldCreatedOptions === true ? createdOptions(firstOptionKey, lastOptionKey) : options.toJS();
    }
  };

  const {
    label,
    id,
    name,
    modifiers = [],
    autoFocus = false,
    tabIndex = 1,
    disabled = false,
    required = false,
    search = true,
    selection = true,
    searchInput = {},
    placeholder,
    info,
  } = props;

  return (
    <FieldSet id={id} label={label} required={required} modifiers={modifiers} errors={errors}>
      <React.Fragment>
        <Dropdown
          name={name}
          value={value}
          selectOnBlur={false}
          disabled={disabled}
          autoFocus={autoFocus}
          options={convertArrayFromDropdown(setOptions())}
          search={search}
          tabIndex={tabIndex}
          onChange={dispatchChangeField}
          selection={selection}
          className="dropdown-custom"
          searchInput={searchInput}
          placeholder={intl.formatMessage({ id: placeholder, defaultMessage: localeData.en[placeholder] })}
        />
        {info && (
          <div className="info_small">
            <FormattedMessageHelper tagName="span" id={info} defaultMessage={localeData.en[info]} />
          </div>
        )}
      </React.Fragment>
    </FieldSet>
  );
};

export default SelectConnect;
